import { Controller } from '@hotwired/stimulus';

export default class CompleteAnswerTestController extends Controller {
  static values = {
    answers:  Array,
    tabIndex: Number
  };

  static targets = [
    'choiceButton',
    'answerLabel',
    'clearButton'
  ];

  answersValueChanged(answers) {
    if (answers.length === 0) {
      this.answerLabelTarget.textContent = '選択してください';
      this.clearButtonTarget.hidden      = true;

      this.dispatch('clearAnswer', {
        detail: {
          tabIndex: this.tabIndexValue
        }
      });
    } else {
      this.answerLabelTarget.textContent = answers.join(' ');
      this.clearButtonTarget.hidden      = false;

      this.dispatch('completeAnswer', {
        detail: {
          answer:   answers.join('/'),
          tabIndex: this.tabIndexValue
        }
      });
    }
  }

  pickAnswer(e) {
    if (this.answersValue.length >= 20) {
      alert('選択できるのは20個までです。');
      return;
    }

    this.answersValue = [...this.answersValue, e.target.value];
  }

  clearAnswers() {
    this.answersValue = [];
  }

  disableControls() {
    for (const el of this.choiceButtonTargets) {
      el.disabled = true;
    }
  }
}
